import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./../scss/account-access.style.scss";
import { getItem, getLocalizedPathFromLocalStorage } from "../helper/localstorage.helper";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

interface RootState {
  auth: {
    user: string | null;
  };
}

export const AccountAccess = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 576);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isLaptop = window.innerWidth >= 576 && window.innerWidth < 1440;
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="cta-section text-center d-flex justify-content-center align-items-center">
      <div className="container">
        <h2 className="cta-heading mb-0">
          {t('ACCOUNT_ACCESS_HEADING_1')} <br className="d-none d-md-block" />
          {t('ACCOUNT_ACCESS_HEADING_2')}
        </h2>
        <div className={`cta-buttons d-flex flex-row justify-content-sm-center align-items-sm-center justify-content-start align-items-start ${isMobile ? 'pt-4 mt-2' : ''} ${isLaptop ? 'pt-5 mt-2' : ''}`}
          style={{ gap: isMobile ? '20px' : '40px' }}

        >
          <button className={`access-btn fw-semibold padding-top bg-light ${isMobile ? ' px-sm-3 py-2' : ' px-sm-4 '} `}
            onClick={() => {
              if (user) {
                navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'kontakta-oss', 'en-us': 'contact-us' }));
              } else {
                navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'e-postinloggning', 'en-us': 'emaillogin' }));
              }
            }}
          >
            {user ? t('CONTACT_US') : (isMobile ? t('LOGIN') : t('ACCESS_YOUR_ACCOUNT'))}
          </button>
          <button className=" create-account padding-top"
            onClick={() => {
              if (user) {
                navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'instrumentbrada/aktiviteter', 'en-us': 'dashboard/activities' }));
              } else {
                navigate(getLocalizedPathFromLocalStorage({ get: (key: string) => getItem(key) ?? null }, { 'sv-se': 'e-postregister', 'en-us': 'emailregister' }));
              }
            }}
          >
            {user ? t('GO_TO_DASHBOARD') : (isMobile ? t('CREATE_ACCOUNT') : t('CREATE_A_FREE_ACCOUNT'))}
          </button>
        </div>
      </div>
    </section>
  );
};
